var hi = {
  "Add Quantity Breaks to your product page": "अपने प्रोडक्ट पेज पर मात्रा छूट जोड़ें",
  "Add Upsell.com to your ": "Upsell.com जोड़ें: ",
  "Add to cart click": "कार्ट में जोड़ें क्लिक",
  "All time": "हर समय",
  "and select": "और चुनें",
  "button": "बटन",
  "Cart drawer page": "कार्ट ड्रॉअर पेज",
  "Cart page": "कार्ट पेज",
  "Check status": "स्टेटस जांचें",
  "Checkout page": "चेकआउट पेज",
  "Checkout click": "चेकआउट क्लिक",
  "Click": "क्लिक करें",
  "Click on": "क्लिक करें",
  "Click the": "पर क्लिक करें",
  "Custom slot": "कस्टम स्लॉट",
  "Custom slots": "कस्टम स्लॉट",
  "Custom Slots": "कस्टम स्लॉट",
  "Enable in theme editor": "थीम एडिटर में सक्षम करें",
  "contact support.": "सपोर्ट से संपर्क करें।",
  "from the right sidebar": "दाएं साइडबार से",
  "Go to App Embeds": "ऐप एम्बेड पर जाएं",
  "Go to your Cart drawer page": "अपने कार्ट ड्रॉअर पेज पर जाएं",
  "Go to your Cart page": "अपने कार्ट पेज पर जाएं",
  "Go to your Checkout page": "अपने चेकआउट पेज पर जाएं",
  "Go to your Order status page": "अपने ऑर्डर स्टेटस पेज पर जाएं",
  "Go to your Post purchase page": "अपने पोस्ट परचेज पेज पर जाएं",
  "Go to your Product page": "अपने प्रोडक्ट पेज पर जाएं",
  "Go to your Thank you page": "अपने थैंक यू पेज पर जाएं",
  "items": "item",
  "in the left sidebar": "बाएं साइडबार में",
  "Last 12 months": "पछिले 12 महीने",
  "Last 30 days": "पछिले 30 दिन",
  "Last 365 days": "पछिले 365 दिन",
  "Last 7 days": "पछिले 7 दिन",
  "Last 90 days": "पछिले 90 दिन",
  "Last month": "पछिले महीने",
  "Last year": "पछिले साल",
  "Make sure": "सुनिश्चित करें",
  "Need assistance? Contact our support team for help.": "सहायता चाहिए? मदद के लिए हमारी सहायता टीम से संपर्क करें।",
  "Order status page": "ऑर्डर स्टेटस पेज",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "आपके अनुभव को बेहतर बनाने के लिए हमारा ऐप अभी थोड़ा अपडेट हो रहा है।",
  "Post purchase page": "पोस्ट परचेज पेज",
  "Product page": "प्रोडक्ट पेज",
  "Save": "सहेजें",
  "Scroll to the bottom and select": "नीचे स्क्रॉल करें और चुनें",
  "Select": "चुनें",
  "Success. Please continue.": "सफलता। कृपया जारी रखें।",
  "Thank you page": "थैंक यू पेज",
  "The Upsell.com team.": "Upsell.com टीम।",
  "The Upsell.com widget is not placed on ": "Upsell.com विजेट ",
  ". Please follow the steps above or ": " पर नहीं रखा गया है। कृपया ऊपर दिए गए चरणों का पालन करें या ",
  "Today": "आज",
  "toggle is on": "ट टॉगल चालू है",
  "Total": "कुल",
  "under": "के नीचे",
  "We apologize for any inconvenience caused,": "किसी भी असुविधा के लिए हम क्षमा चाहते हैं,",
  "We apologize for any inconvenience caused.": "किसी भी असुविधा के लिए हम क्षमा चाहते हैं।",
  "We'll be done in a few minutes!": "हम कुछ ही मिनटों में तैयार हो जाएंगे!",
  "We're improving our services!": "हम अपनी सेवाओं में सुधार कर रहे हैं!",
  "Widget already added": "विजेट पहले से जोड़ा गया है",
  "Yesterday": "कल",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "आपने अपने ऑनलाइन स्टोर में विजेट सक्षम किया, लेकिन उसे Upsell एडिटर में सेव नहीं किया",
  "You placed the widget on the ": "आपने विजेट को ",
  ", but you didn't save it in Shopify editor. Please go back to ": " पर रखा है, लेकिन आपने इसे Shopify एडिटर में सेव नहीं किया। कृपया ",
  " and save the changes.": " पर वापस जाएं और बदलाव सेव करें।"
};

export { hi as default };
//# sourceMappingURL=hi.json.js.map
